import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import {
  DialogBackDrop,
  DialogContainer,
  // DialogInnerContainer
} from './skins';

export default function Dialog({ open, popupType, children, ...props }) {
  const [shouldRender, setRender] = useState(open);
  const bodyElement = document.getElementsByTagName('body')[0];
  let containerElement = document.getElementById('mr-dialog');

  if (containerElement === null) {
    containerElement = document.createElement('div');
    containerElement.setAttribute('id', 'mr-dialog');
    bodyElement.appendChild(containerElement);
  }

  const onAnimationEnd = () => {
    if (!open) setRender(false);
  };

  useEffect(
    () => {
      bodyElement.style.overflow = 'hidden';
      if (open) {
        setRender(true);
      }
      return () => {
        if (containerElement && !open) {
          bodyElement.style.overflow = 'auto';
          bodyElement.removeChild(containerElement);
        }
      };
    },
    [open],
  );

  const handleBackdropClick = () => {
    if (props.isPopupBackdropClickEnabled) {
      props.onBackdropClick();
    }
  };

  if (shouldRender) {
    return ReactDOM.createPortal(
      <>
        {/* {!props.noBackDrop && ( */}
        <DialogBackDrop
          noBackDrop={props.noBackDrop}
          className={`mr-dialog-backdrop ${open ? 'mr-fadeIn' : 'mr-fadeOut'}`}
          onAnimationEnd={onAnimationEnd}
          onClick={handleBackdropClick}
        />
        <DialogContainer
          popupType={popupType}
          className={`mr-dialog ${
            open ? 'mr-transition-in' : 'mr-transition-out'
          }`}
          {...props}
          onAnimationEnd={onAnimationEnd}
        >
          {/* <DialogInnerContainer {...props}>
            </DialogInnerContainer> */}
          {children}
        </DialogContainer>
      </>,
      containerElement,
    );
  }

  return null;
}
